import {
  validDimensionSlug,
  convertSlugToDimensionName,
} from '@features/reports';
import {
  groupByDimension,
  paginateSubdimensions,
} from '../domain/subdmensions';
import { Lci3DimensionTableData, isTopBottomName } from '@features/lci-report';
import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { Slide } from '@features/powerpoint';

type RenderProps = {
  subdimensions: Lci3Report['subdimensions'];
  dimensionName: string;
  dimensionSlug: string;
  page: number;
  totalPages: number;
};

export const renderTableWithSubdimensions = (
  dimensionTableData: Lci3DimensionTableData,
  subdimensionsPerSlide: number,
  renderFn: (renderProps: RenderProps) => Slide
) => {
  const subdimensionsByPage = paginateSubdimensions(
    dimensionTableData,
    subdimensionsPerSlide
  );

  const groupedByDimension = groupByDimension(subdimensionsByPage);

  return Object.entries(groupedByDimension)
    .filter(([slug]) => !isTopBottomName(slug))
    .flatMap(([_, dimensionPage]) =>
      dimensionPage.map(({ dimension, subdimensions }, index) => {
        const fullDimensionName = validDimensionSlug(dimension)
          ? convertSlugToDimensionName(dimension)
          : dimension;

        return renderFn({
          subdimensions,
          dimensionName: fullDimensionName,
          dimensionSlug: dimension,
          page: index + 1,
          totalPages: groupedByDimension[dimension]?.length ?? 0,
        });
      })
    );
};
